import { Circle, Fill, Stroke, Style } from "ol/style";

/** Copied from https://openlayers.org/en/latest/apidoc/module-ol_style_Style-Style.html */
export const olDefaultStyle: Style[] = (() => {
  const fill = new Fill({
    color: "rgba(255,255,255,0.4)",
  });

  const stroke = new Stroke({
    color: "#3399CC",
    width: 1.25,
  });

  return [
    new Style({
      image: new Circle({
        fill: fill,
        stroke: stroke,
        radius: 5,
      }),
      fill: fill,
      stroke: stroke,
    }),
  ];
})();

/** System fallback for deleted function types ("Niet toegewezen"). */
export const NIET_TOEGEWEZEN_LABEL = "Niet toegewezen";

let hatchPattern: CanvasPattern | string | null = null;

function getHatchPattern(): CanvasPattern | string {
  if (hatchPattern) {
    return hatchPattern;
  }
  if (typeof document === "undefined") {
    hatchPattern = "rgba(128,128,128,0.45)";
    return hatchPattern;
  }
  const canvas = document.createElement("canvas");
  canvas.width = 8;
  canvas.height = 8;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    hatchPattern = "rgba(128,128,128,0.45)";
    return hatchPattern;
  }
  ctx.fillStyle = "rgba(200,200,200,0.35)";
  ctx.fillRect(0, 0, 8, 8);
  ctx.strokeStyle = "#555555";
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.moveTo(0, 8);
  ctx.lineTo(8, 0);
  ctx.moveTo(-2, 2);
  ctx.lineTo(2, -2);
  ctx.moveTo(6, 10);
  ctx.lineTo(10, 6);
  ctx.stroke();
  hatchPattern = ctx.createPattern(canvas, "repeat") || "rgba(128,128,128,0.45)";
  return hatchPattern;
}

export const nietToegewezenStyle: Style[] = [
  new Style({
    fill: new Fill({
      color: getHatchPattern() as any,
    }),
    stroke: new Stroke({
      color: "#444444",
      width: 1.25,
      lineDash: [4, 4],
    }),
  }),
];
